<template>
  <mu-container>
    <mu-form ref="form" :model="validateForm" class="mu-demo-form">
      <mu-form-item label="*聯絡人姓名" prop="username" class="general-information" :class="{has_error : errorMsg.username}">
        <mu-text-field v-model.trim="validateForm.username" v-on:input="typeUsername" prop="username"></mu-text-field>
        <div class="error_msg"><span v-if="errorMsg.username">請輸入聯絡人姓名</span></div>
      </mu-form-item>
      <mu-form-item label="*聯絡電話" prop="phone" class="general-information" :class="{has_error : errorMsg.phone}">
        <mu-text-field type="tel" id="phone" v-model.trim="validateForm.phone" v-on:input="typePhone" prop="phone"></mu-text-field>
        <div class="error_msg"><span v-if="errorMsg.phone">請輸入聯絡電話</span></div>
      </mu-form-item>
      <mu-form-item label="*Email" prop="email" class="general-information" :class="{has_error : errorMsg.email}">
        <mu-text-field type="email" id="email" v-model.trim="validateForm.email" v-on:input="typeEmail" prop="email"></mu-text-field>
        <div class="error_msg"><span v-if="errorMsg.email">請輸入Email</span></div>
      </mu-form-item>
      <mu-form-item label="公司名稱" prop="comanyName" class="general-information">
        <mu-text-field type="text" v-model.trim="validateForm.organization_name"></mu-text-field>
      </mu-form-item>
      <mu-form-item label="公司電話" prop="comanyTel" class="general-information mb-5">
        <mu-text-field type="tel" v-model.trim="validateForm.organization_phone"></mu-text-field>
      </mu-form-item>
      <div class="custom-form">
        <div class="option-wrap d-flex">
          <div class="program-option">案件類型 (可複選)：</div>
          <div class="option-group">
            <div class="option">
              <input v-model="validateForm.program_option" type="checkbox" value="web" id="web-design" checked>
              <label for="web-design">Web<br>網站設計</label>
            </div>
            <div class="option">
              <input v-model="validateForm.program_option" type="checkbox" value="graphic" id="graphic-design">
              <label for="graphic-design">Design<br>平面設計</label>
            </div>
            <div class="option">
              <input v-model="validateForm.program_option" type="checkbox" value="brand" id="brand-design">
              <label for="brand-design">Brand<br>品牌設計</label>
            </div>
            <div class="option">
              <input v-model="validateForm.program_option" type="checkbox" value="cp-motion" id="cp-motion">
              <label for="cp-motion">CP / MOTION<br>攝影 / 影像</label>
            </div>
          </div>
        </div>
        <div class="option-wrap d-flex">
          <div class="program-option">案件狀態：</div>
          <div class="option-group">
            <div class="option">
              <input v-model="validateForm.program_status" type="radio" id="New" value="new" name="program-status"
                checked>
              <label for="New">New<br>全新專案</label>
            </div>
            <div class="option">
              <input v-model="validateForm.program_status" type="radio" id="Redesign" value="fixed" name="program-status">
              <label for="Redesign">Redesign<br>既有增修</label>
            </div>
          </div>
        </div>
      </div>
      <div class="time-wrap d-flex justify-content-between">
        <div class="program-time">
          <mu-date-input v-model="validateForm.program_time_start" v-on:input="formatStart(validateForm.program_time_start)" label="預計專案進行時間" label-float full-width></mu-date-input>
        </div>
        <div class="program-time">
          <mu-date-input v-model="validateForm.program_time_end" v-on:input="formatEnd(validateForm.program_time_end)" label="預計專案結束時間" label-float full-width></mu-date-input>
        </div>
      </div>
      <textarea class="message" name="" id="" cols="30" rows="10" v-model="validateForm.message" placeholder="備註"></textarea>
      <button type="button" class="submit-btn rounded-0" @click="submit">提交</button>
    </mu-form>
  </mu-container>
</template>

<script>
  export default {
    props: ["modal"],
    data() {
      return {
        errorMsg: {
          username: false,
          phone: false,
          email: false,
        },
        validateForm: {
          username: '',
          phone: '',
          email: '',
          organization_name: '',
          organization_phone: '',
          program_option: ['web'],
          program_status: 'new',
          program_time_start: undefined,
          program_time_end: undefined,
          message: ''
        },
        valid: {},
      }
    },
    methods: {
      submitSuccess() {
        this.$emit('callSuccess')
      },
      typeUsername() {
        let vm = this;
        var form = vm.validateForm;
        if (form.username.length <= 0) {
          this.errorMsg.username = true;
        } else {
          this.errorMsg.username = false;
        }
      },
      typePhone() {
        let vm = this;
        var form = vm.validateForm;
        if (form.phone.length <= 0) {
          this.errorMsg.phone = true;
        } else {
          this.errorMsg.phone = false;
        }
      },
      typeEmail() {
        let vm = this;
        var form = vm.validateForm;
        if (form.email.length <= 0) {
          this.errorMsg.email = true;
        } else {
          this.errorMsg.email = false;
        }
      },
      formatStart(date){
        let vm = this;
        let formatted = new Date(date);
        let year = formatted.getFullYear().toString();
        let month = ("0" + (formatted.getMonth() + 1).toString()).slice(-2);
        let day = ("0" + (formatted.getDate().toString())).slice(-2);
        let result = `${year}-${month}-${day}`;
        return vm.validateForm.program_time_start = result;
      },
      formatEnd(date){
        let vm = this;
        let formatted = new Date(date);
        let year = formatted.getFullYear().toString();
        let month = ("0" + (formatted.getMonth() + 1).toString()).slice(-2);
        let day = ("0" + (formatted.getDate().toString())).slice(-2);
        let result = `${year}-${month}-${day}`;
        return vm.validateForm.program_time_end = result;
      },
      submit() {
        let vm = this;
        var form = vm.validateForm;
        // form.program_option = form.program_option.join()
        var is_send = true;
        if (form.username.length <= 0) {
          this.errorMsg.username = true;
          is_send = false;
        }
        if (form.phone.length <= 0) {
          this.errorMsg.phone = true;
          is_send = false;
        }
        if (form.email.length <= 0) {
          this.errorMsg.email = true;
          is_send = false;
        }
        if (is_send)
          vm.axios({
            method: "post",
            url: process.env.VUE_API_URL + "v1/email/send",
            params: form
          })
          .then(function (response) {
            //console.log(response.data)
            if (response.status == 200) {
              vm.valid = response.data;
              form.username = form.phone = form.email = form.organization_name = form.organization_phone = form.message =
                '';
              form.program_option = ['web'];
              form.program_status = 'new';
              form.program_time_start = form.program_time_end = undefined;
              //console.log(vm.valid);
              vm.submitSuccess();
            } else {
              console.log('失敗')
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
    },
    watch:{
      validateForm(){

      }
    }
  };

</script>
<style lang="scss" scoped>
  @import 'src/assets/scss/common.scss';

  .mu-demo-form {
    width: 100%;
  }

  .general-information {
    >.mu-form-item-label {
      font-size: 0.875rem;
      font-weight: bold;
      line-height: 1.21;
      letter-spacing: 1.4px;
      padding-left: 10.5px;
      color: #4d4d4d;
    }
  }

  .mu-form-item__has-label {
    min-height: auto;
    padding-bottom: 0;
  }

  .mu-input {
    margin-bottom: 4px;
  }

  .error_msg {
    color: red;
    font-size: 12px;
    width: 100%;
    height: 18px;
    letter-spacing: 1.2px;
  }

  .option-wrap {
    margin-bottom: 50px;
    flex-wrap: wrap;

    @media screen and (max-width: 1350px) {
      flex-wrap: wrap;
    }

    @media screen and (max-width: 768px) {
      margin-bottom: 20px;
    }

    .program-option {
      width: 100%;
      font-weight: 500;
      letter-spacing: 2.4px;
      color: black;
      margin-bottom: 30px;
    }
    .option-group{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      @media screen and (max-width: 1350px) {
        width: 100%;
      }
      .option {
        position: relative;
        margin-right: 30px;
        margin-bottom: 15px;

        @media screen and (max-width: 768px) {
          margin-right: 24px;
        }

        >input {
          position: absolute;
          width: 100%;
          height: 100%;
          visibility: hidden;

          &:checked {
            +label {
              color: #4d4d4d;

              &::before {
                opacity: 1;
              }
            }
          }
        }

        label {
          width: 100%;
          height: 66px;
          padding: 10px 30px;
          margin-bottom: 0;
          color: rgba(0, 0, 0, .54);

          &::before {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            border: solid 2px #00e1ff;
            cursor: pointer;
            opacity: 0;
            transition: opacity 0.2s linear;
          }
        }
      }
    }
  }

  .time-wrap {
    margin-bottom: 40px;

    @media screen and (max-width: 768px) {
      flex-wrap: wrap;
    }

    .program-time {
      width: calc((100% - 30px) / 2);

      @media screen and (max-width: 768px) {
        width: 100%;
      }

      &:first-child {
        margin-right: 30px;

        @media screen and (max-width: 768px) {
          margin-right: 0;
        }
      }

      .mu-input-label {
        transform: translateZ(0) translateY(-10px) scale(1);
      }

      .mu-input.has-label {
        min-height: auto;
        margin-bottom: 0;
        padding-bottom: 0;

        .mu-input-label {

          &.float {
            font-weight: 500;
            letter-spacing: 2.4px;
            color: black;
          }
        }
      }
    }
  }

  .message {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, .12);
    margin-bottom: 50px;

    &:focus {
      border: 1px solid rgba(33, 150, 243, 1);
      outline: none;
    }

    &::placeholder {
      color: rgba(0, 0, 0, .54);
    }

    &:-ms-input-placeholder {
      color: rgba(0, 0, 0, .54);
    }

    &::-ms-input-placeholder {
      color: rgba(0, 0, 0, .54);
    }
  }

  .submit-btn {
    display: block;
    width: 270px;
    height: 60px;
    line-height: 60px;
    border: none;
    padding: 0;
    color: $main-color;
    background-color: $common1;
    font-size: 1.375rem;
    letter-spacing: 0.02065rem;
    margin: 0 auto;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      width: calc(100% - 54px);
      font-size: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/infiniteForm.vue